import baseApi from './baseApi';

export const tradingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Orders
    getOrders: builder.query({
      query: (userId) => ({
        url: `/customer/${userId}/orders`,
        method: 'POST',
      }),
      providesTags: ['Orders'],
    }),

    // Positions
    getPositions: builder.query({
      query: (userId) => ({
        url: `/customer/${userId}/positions`,
        method: 'POST',
      }),
      providesTags: ['Positions'],
    }),

    // Holdings
    getHoldings: builder.query({
      query: (userId) => ({
        url: `/customer/${userId}/holdings`,
        method: 'POST',
      }),
      providesTags: ['Holdings'],
    }),

    // Funds
    getFunds: builder.query({
      query: (userId) => ({
        url: `/customer/${userId}/funds`,
        method: 'POST',
      }),
      providesTags: ['Funds'],
    }),

    // Subscription
    addSubscription: builder.mutation({
      query: (advisorId) => ({
        url: '/users/subscriptions',
        method: 'POST',
        body: { advisorId },
      }),
      invalidatesTags: ['Auth', 'SubscriptionStatus'],
    }),


    getSubscriptionStatus: builder.query({
      query: () => '/users/me',
      transformResponse: (response) => response.subscriptions || [],
      providesTags: ['SubscriptionStatus'],
    }),

    unsubscribe: builder.mutation({
      query: ({ advisorId, userId }) => ({
        url: '/users/unsubscribe',
        method: 'DELETE',
        body: { advisorId, userId },
      }),
      invalidatesTags: ['Auth', 'SubscriptionStatus'],
    }),
  }),
});


export const {
  useGetOrdersQuery,
  useGetPositionsQuery,
  useGetHoldingsQuery,
  useGetFundsQuery,
  useAddSubscriptionMutation,
  useGetSubscriptionStatusQuery,
  useUnsubscribeMutation,
} = tradingApi;

export default tradingApi;
